module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgAgMAAACf9p+rAAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAABHRSTlMAb/+PHjuJRAAAAGBJREFUeAHtzzEVwEAIBFGkIRERNBwUSEBa2qSYlxPAdPt+tbLdt21KYAROEARHCYzACYLgKIEROEG8xyclMAInCIIkKIImGDiYAlAETTAAKQBF0AQDkAIVQROM/LVt2wMdg3MxJZB+jwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right-icon.png
// module id = 25
// module chunks = 0